import { apiClient } from 'pobble-components/dist/api'

const schoolsSearch = params => apiClient.get('v3/schools_search', { params })

export { schoolsSearch }
